import { FetchError as OfetchError } from 'ofetch'

import type { ProblemValidationErrorMember } from '@backmarket/http-api/src/api-models/ProblemValidationErrorMember'
import { HttpApiError } from '@backmarket/http-api/src/utils/HttpApiError'

type GetAPIValidationErrorsOptions = {
  targetToFieldIdMapper?: (apiTarget: string) => string
  getLocalizedErrorMessage?: (
    error: ProblemValidationErrorMember,
  ) => string | undefined
}

/**
 * Transform an HttpApiError instance into a localized record of fieldId => errorMessage
 */
export const getAPIValidationErrors = (
  error: unknown,
  options: GetAPIValidationErrorsOptions = {},
): Record<string, string> => {
  const {
    targetToFieldIdMapper = (apiTarget) => apiTarget,
    getLocalizedErrorMessage,
  } = options

  let errors = []
  if (error instanceof HttpApiError) {
    // eslint-disable-next-line prefer-destructuring
    errors = error.errors
  } else if (error instanceof OfetchError) {
    // eslint-disable-next-line prefer-destructuring
    errors = error.data.errors
  }

  return errors.reduce(
    (
      acc: Record<string, string>,
      validationError: ProblemValidationErrorMember,
    ) => {
      return {
        ...acc,
        [targetToFieldIdMapper(validationError.target)]:
          getLocalizedErrorMessage?.(validationError) ?? validationError.title,
      }
    },
    {},
  )

  return {}
}
